<div class="row">
  <!-- tabs card start -->
  <div class="col-sm-12">
    <app-card moduleName="Admin" module="Admin" (addUser)="createAdmin($event)" cardClass="table-card" blockClass="p-0">
      <!-- <perfect-scrollbar [style.max-height]="'415px'"> -->

      <p-table #dt [value]="adminUserList" [(selection)]="selectedAdmin" dataKey="_id" styleClass="ui-table-customers"
        [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50, 100]"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0" [globalFilterFields]="searchArr">
        <ng-template pTemplate="caption">
          <div class="ui-table-globalfilter-container">
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="Global Search" />
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
              <b>{{ col.header }}</b>
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>

            <th></th>
            <!-- <th>View</th>
                    <th>Delete</th> -->
            <th *ngIf="checkPermissions('edit', 'Admin')"></th>
          </tr>
          <tr>
            <th *ngFor="let col of cols" [ngSwitch]="col.field">
              <input pInputText type="text" class="ui-inputtext"
                (input)="dt.filter($event.target.value, col.field, 'contains')" />
            </th>
            <th></th>
            <!-- <th></th> -->
            <th *ngIf="checkPermissions('edit', 'Admin')"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-car>
          <tr *ngIf="!showLoader">
            <td *ngFor="let col of cols" (click)="viewAdmin($event, car)">
              {{ car[col.field] }}
            </td>

            <!-- <td>
                      <span (click)='editSubject($event,car)'>
                        <i class='fa fa-pencil fa-2x'></i>
                      </span>
                    </td> -->
            <td *ngIf="checkPermissions('edit', 'Admin')">
              <span>
                <p-checkbox name="active" ngDefaultControl [(ngModel)]="car.active"
                  class="map-checkbox text-allign-btns" (onChange)="change($event, car)" label="Active"
                  binary="false"></p-checkbox>
              </span>
              <span (click)="navigateToUsersAccess(car?._id)">
                <a href="javascript:void(0);"> Access</a>
              </span>
            </td>
            <td>
              <span (click)="viewAdmin($event, car)" pTooltip="Click to view a Admin" tooltipPosition="top"
                class="mob_icon style-toggler">
                <i class="fa fa-eye fa-2x"></i>
              </span>
              <span (click)="editAdmin($event, car)" pTooltip="Click to edit a Admin" tooltipPosition="top"
                class="mob_icon style-toggler delete_icon" *ngIf="checkPermissions('edit', 'Admin')">
                <i class="fa fa-edit fa-2x"></i>
              </span>
              <span (click)="deleteAdmin(car._id)" pTooltip="Click to delete a Admin" tooltipPosition="top"
                class="style-toggler mob_icon delete_icon" *ngIf="checkPermissions('delete', 'Admin')">
                <i class="fa fa-trash fa-2x"></i>
              </span>
              <!-- <span *ngIf="!car.delete">
                          -
                        </span> -->
            </td>
          </tr>
        </ng-template>
        <ng-template class="noRecords" *ngIf="adminUserList.length == 0" pTemplate="emptymessage">
          <tr class="noRecords" *ngIf="!showLoader">
            <td [attr.colspan]="cols.length + 2">
              <!-- <div class="my-center-text"> -->
              No Records to display
              <!-- </div> -->
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- </perfect-scrollbar> -->
      <div class="loader" *ngIf="showLoader"></div>
    </app-card>
  </div>
  <!-- tabs card end -->
</div>

<div *ngIf="showAdd">
  <app-add-edit-admin-users [isView]="isView" [data]="adminData"
    (closeEvents)="callList($event)"></app-add-edit-admin-users>
</div>